export default "__VITE_ASSET__DLvgBG6$__"